import { playdataLegalPageQueryOptions } from "@data/public-page-data-query"
import * as m from "@paraglide/messages"
import PlaydataLegalBody from "@playdata/PlaydataLegalBody"
import type { SupportedLocale } from "@site-types/content"
import { createFileRoute } from "@tanstack/react-router"
import { playdataRouteHead } from "@utils/playdata-route-head"

export const Route = createFileRoute("/$locale/playdata/privacy")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      playdataLegalPageQueryOptions("playdataPrivacy", params.locale as SupportedLocale)
    ),
  head: ({ params }) => {
    const locale = params.locale as SupportedLocale
    return playdataRouteHead({
      description: m.playdata_privacy_meta_description({}, { locale }),
      locale,
      path: "/playdata/privacy",
      title: m.playdata_privacy_meta_title({}, { locale }),
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: raw } = Route.useParams()
  const locale = raw as SupportedLocale
  const document = Route.useLoaderData()
  return (
    <PlaydataLegalBody
      body={document?.body ?? ""}
      heading={document?.title || m.playdata_privacy_heading({}, { locale })}
    />
  )
}
